import { Injectable } from '@angular/core';
import { BaseService } from '../../common/services/base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Availability } from '../../common/interfaces/availability.interface';
import { map } from 'rxjs/operators';

@Injectable()
export class AvailabilityService extends BaseService {

    constructor(private http: HttpClient) {
        super();
    }

    getAvailability(): Observable<Availability> {
        return this.http.get(this.getApiUrl() + '/system/availability')
            .pipe(map((res: any) => res || {}));
    }
}
